
import { computed, defineComponent, reactive, watch } from "vue";

export default defineComponent({
  name: "Arrow",
  props: {
    fromX: {
      type: Number,
      required: true,
    },
    fromY: {
      type: Number,
      required: true,
    },
    toX: {
      type: Number,
    },
    toY: {
      type: Number,
    },
    transition: {
      type: Boolean,
      required: false,
    },
  },

  setup(props) {
    const to = reactive<{ x?: number; y?: number }>({});
    const windowSize = reactive({
      width: window.innerWidth,
      height: window.innerHeight,
    });
    const dimensions = {
      arrowBodyWidth: 38.738945,
      arrowBodyOffset: 88.907135,
      arrowWidth: 90,
    };

    const angle = computed(() => {
      if (!(typeof to.x === "number" && typeof to.y === "number")) return 0;
      let a = Math.atan2(to.y - props.fromY, to.x - props.fromX);
      return (a * 180) / Math.PI + 90;
    });

    const height = computed(() =>
      typeof to.x === "number" && typeof to.y === "number"
        ? Math.sqrt(
            Math.pow(to.y - props.fromY, 2) + Math.pow(to.x - props.fromX, 2)
          )
        : 0
    );

    const handler = (e: MouseEvent) => {
      to.x = e.pageX;
      to.y = e.pageY;
    };

    const assignToCoords = () => {
      window.removeEventListener("mousemove", handler);
      if (typeof props.toX === "number" && typeof props.toY === "number") {
        to.x = props.toX;
        to.y = props.toY;
      } else window.addEventListener("mousemove", handler);
    };
    watch([() => props.toX, () => props.toY], assignToCoords);
    assignToCoords();

    window.addEventListener("resize", () => {
      windowSize.width = window.innerWidth;
      windowSize.height = window.innerHeight;
    });

    return {
      to,
      windowSize,
      dimensions,
      angle,
      height,
    };
  },
});
